/**
 * Who counts as an admin in the browser.
 *
 * Matches the backend's middleware/adminAuth.js: role admin or super_admin,
 * or an email on the protected break-glass list (keep it in lockstep with the
 * backend list). The backend still checks every admin request; this only
 * decides what the browser shows.
 */
export const PROTECTED_ADMIN_EMAILS = ['cearlgo@icloud.com', 'workwithchante@gmail.com', 'admin@canira.io'];

// A protected admin's role can't be changed from the console (backend
// utils/adminRoleChange.js): a super admin, or an address on the list above.
export function isProtectedAdmin(user) {
  if (!user) return false;
  if (user.role === 'super_admin') return true;
  return PROTECTED_ADMIN_EMAILS.includes(String(user.email || '').toLowerCase());
}

export function isAdminUser(user) {
  if (!user) return false;
  if (user.role === 'admin' || user.role === 'super_admin') return true;
  return PROTECTED_ADMIN_EMAILS.includes(String(user.email || '').toLowerCase());
}
